import { Helmet } from 'react-helmet-async';
import { Hero } from '@/components/sections/Hero';
import { AboutCoffee } from '@/components/sections/AboutCoffee';
import { FreshBread } from '@/components/sections/FreshBread';
import { PhotoGallery } from '@/components/sections/PhotoGallery';
import { LocationMap } from '@/components/sections/LocationMap';

export function Index() {

  return (
    <>
      <Helmet>
        <title>Diana's Morning Brew – Tilton NH – Breakfast & Lunch</title>
        <meta name="description" content="Enjoy fresh brewed New Hampshire coffee at Diana's Morning Brew. Fresh baked bread daily, breakfast & lunch in Tilton, NH. Come out of your shell!" />
        <meta name="keywords" content="Diana's Morning Brew, Tilton NH, breakfast, lunch, fresh coffee, New Hampshire, fresh bread, cafe, restaurant" />
        <meta name="robots" content="max-image-preview:large" />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
        <meta name="format-detection" content="telephone=no" />
        
        {/* Open Graph tags for social media */}
        <meta property="og:title" content="Diana's Morning Brew – Tilton NH – Breakfast & Lunch" />
        <meta property="og:description" content="Enjoy fresh brewed New Hampshire coffee at Diana's Morning Brew. Fresh baked bread daily, breakfast & lunch in Tilton, NH." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://dianasmorningbrew.com/" />
        <meta property="og:site_name" content="Diana's Morning Brew" />
        
        {/* Twitter Card tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Diana's Morning Brew – Tilton NH – Breakfast & Lunch" />
        <meta name="twitter:description" content="Enjoy fresh brewed New Hampshire coffee at Diana's Morning Brew. Fresh baked bread daily, breakfast & lunch in Tilton, NH." />
        
        {/* Local business structured data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Restaurant",
            "name": "Diana's Morning Brew",
            "description": "Fresh coffee, breakfast & lunch restaurant in Tilton, New Hampshire",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "267 Main St., Suite 600",
              "addressLocality": "Tilton",
              "addressRegion": "New Hampshire",
              "postalCode": "03276"
            },
            "telephone": "603-729-0297",
            "url": "https://dianasmorningbrew.com",
            "servesCuisine": ["American", "Breakfast", "Coffee"],
            "priceRange": "$$"
          })}
        </script>
        
        {/* Font imports for Hero section */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link 
          href="https://fonts.googleapis.com/css2?family=Bebas+Neue:wght@400@700&family=Roboto:wght@400;500;700&display=swap"
          rel="stylesheet"
        />
        <link 
          href="https://fonts.googleapis.com/css2?family=Carattere&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      
      <div className="min-h-screen bg-cream-base">
        <main>
          <Hero />
          <AboutCoffee />
          <FreshBread />
          <PhotoGallery />
          <LocationMap />
        </main>
      </div>
    </>
  );
}